module.exports = __webpack_public_path__ + "img/btn_heart_off.c8523f47.svg";